// MarketContext.jsx
import React, { createContext, useContext, useRef } from "react";
import { useLocation } from "react-router-dom";

const MarketContext = createContext(null);

export function MarketProvider({ children }) {
    const { search } = useLocation();
    // مقدار اولیه فقط یک‌بار از location.search خوانده می‌شود
    const initial = useRef(new URLSearchParams(search).get("market") ?? null);

    return (
        <MarketContext.Provider value={initial.current}>
            {children}
        </MarketContext.Provider>
    );
}

export function useMarket() {
    return useContext(MarketContext);
}
